var config = {
  XFYUN: '//www.xfyun.cn/',
  PASSPORT: '//signup.xfyun.cn/',
  PASSPORT_old: '//member.xfyun.cn/',
  PASSPORT_NEW: '//passport.xfyun.cn/',
  CONSOLE: '//console.xfyun.cn/',
  CONSOLE_API: '//console.xfyun.cn/',
  AUTH_SITE: '//sso.xfyun.cn/',
  SSOURL: '//www.xfyun.cn/user-server/user-service/',
  AICOLLEGE: '//www.aidaxue.com/',
  AICOLLEGE_URL: '//www.aidaxue.com/',
  API: '/',
  // CDN: 'http://static.xfyun.cn/'
  CDN: '/',
  SECID: 'b96c666cbced4ea4973d621eef8bfff7',
  SEQCID: '07c69cc24f374638b83fa629ebc4b0d0',
  SEQTID: '02770f36bb3148dab0862b1c8b99fcf7',
  SERTASRID: '2bb3e66a714e4be7b81b1ee31d2e5cb1',
  SEGJPCID: 'efac53573d2541fe90f2ad5e595c05d3',
  SEJQFYID: '56d8835eae564f4392ce8cc0cd1a3c4c',
  SEZXFYRID: '1dc02c2cd43a48f49a54b3f283725893',
  SEKTFYID: 'a0e01d0117ff48f594c1a9069d777f6d',
  SOCID: 'e0fad3da773742e58e0a19045aeb582f',
  CPFWSQID: 'b96c666cbced4ea4973d621eef8bfff7',
  DHJQRNLZJJID: '89af4d9885894be387a578f410664472',
  TSYJYID: '6dacf963d6c645c3806513421607643b',
  ELSESQID: '03dd06b27d034b449529ec438314b730',
  OTSTID: '334aacf41bb449b4a3acbc4197633090',
  COUNTCATEGORY: '982ffd3fe55d45659902f1eabb149dad',
  COUNTTID: 'd212e4016410403a9ee4f16dd43f2712',
  HDRKID: 'a7a922c4cd9441e8a1fdbb193fb49c40', // 活动入口
  RTATID: '2bb3e66a714e4be7b81b1ee31d2e5cb1'
}
export {config}



// WEBPACK FOOTER //
// ./src/js/config/prod.js